/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminCohortsResponse,
  AllCohortsResponse,
  CohortClientResponse,
  CohortCreateRequest,
  CohortDetails,
  CohortTemplatesResponse,
  CohortUpdateRequest,
  GetAdminCohortsParams,
  HTTPValidationError,
} from './platformapi.schemas';

import getAdminCohortsMutator from '../custom-axios-instance';
import getAllCohortsMutator from '../custom-axios-instance';
import getCohortClientsMutator from '../custom-axios-instance';
import createCohortMutator from '../custom-axios-instance';
import getCohortTemplatesMutator from '../custom-axios-instance';
import updateCohortDetailsMutator from '../custom-axios-instance';
import getCohortDetailsMutator from '../custom-axios-instance';

/**
 * @summary Get Admin Cohorts
 */
export const getAdminCohorts = (params?: GetAdminCohortsParams, signal?: AbortSignal) => {
  return getAdminCohortsMutator<AdminCohortsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/cohorts/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAdminCohortsQueryKey = (params?: GetAdminCohortsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/cohorts/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminCohortsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminCohorts>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCohorts>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminCohortsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCohorts>>> = ({ signal }) =>
    getAdminCohorts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminCohorts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCohortsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCohorts>>>;
export type GetAdminCohortsQueryError = void | HTTPValidationError;

export function useGetAdminCohorts<
  TData = Awaited<ReturnType<typeof getAdminCohorts>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetAdminCohortsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCohorts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCohorts>>,
          TError,
          Awaited<ReturnType<typeof getAdminCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminCohorts<
  TData = Awaited<ReturnType<typeof getAdminCohorts>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCohorts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCohorts>>,
          TError,
          Awaited<ReturnType<typeof getAdminCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminCohorts<
  TData = Awaited<ReturnType<typeof getAdminCohorts>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Admin Cohorts
 */

export function useGetAdminCohorts<
  TData = Awaited<ReturnType<typeof getAdminCohorts>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminCohortsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get All Cohorts
 */
export const getAllCohorts = (signal?: AbortSignal) => {
  return getAllCohortsMutator<AllCohortsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/cohorts/all`,
    method: 'GET',
    signal,
  });
};

export const getGetAllCohortsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/cohorts/all`] as const;
};

export const getGetAllCohortsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllCohorts>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCohorts>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllCohortsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCohorts>>> = ({ signal }) =>
    getAllCohorts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllCohorts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllCohortsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCohorts>>>;
export type GetAllCohortsQueryError = void | HTTPValidationError;

export function useGetAllCohorts<
  TData = Awaited<ReturnType<typeof getAllCohorts>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCohorts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCohorts>>,
          TError,
          Awaited<ReturnType<typeof getAllCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllCohorts<
  TData = Awaited<ReturnType<typeof getAllCohorts>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCohorts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCohorts>>,
          TError,
          Awaited<ReturnType<typeof getAllCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllCohorts<
  TData = Awaited<ReturnType<typeof getAllCohorts>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get All Cohorts
 */

export function useGetAllCohorts<
  TData = Awaited<ReturnType<typeof getAllCohorts>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllCohortsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Cohort Clients
 */
export const getCohortClients = (signal?: AbortSignal) => {
  return getCohortClientsMutator<CohortClientResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/cohorts/clients`,
    method: 'GET',
    signal,
  });
};

export const getGetCohortClientsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/cohorts/clients`] as const;
};

export const getGetCohortClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohortClients>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortClients>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortClientsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohortClients>>> = ({ signal }) =>
    getCohortClients(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohortClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCohortClientsQueryResult = NonNullable<Awaited<ReturnType<typeof getCohortClients>>>;
export type GetCohortClientsQueryError = void | HTTPValidationError;

export function useGetCohortClients<
  TData = Awaited<ReturnType<typeof getCohortClients>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortClients>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohortClients>>,
          TError,
          Awaited<ReturnType<typeof getCohortClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohortClients<
  TData = Awaited<ReturnType<typeof getCohortClients>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortClients>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohortClients>>,
          TError,
          Awaited<ReturnType<typeof getCohortClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohortClients<
  TData = Awaited<ReturnType<typeof getCohortClients>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortClients>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Cohort Clients
 */

export function useGetCohortClients<
  TData = Awaited<ReturnType<typeof getCohortClients>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortClients>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCohortClientsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Cohort
 */
export const createCohort = (cohortCreateRequest: CohortCreateRequest, signal?: AbortSignal) => {
  return createCohortMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/cohorts/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: cohortCreateRequest,
    signal,
  });
};

export const getCreateCohortMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCohort>>,
    TError,
    { data: CohortCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCohort>>,
  TError,
  { data: CohortCreateRequest },
  TContext
> => {
  const mutationKey = ['createCohort'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCohort>>,
    { data: CohortCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createCohort(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCohortMutationResult = NonNullable<Awaited<ReturnType<typeof createCohort>>>;
export type CreateCohortMutationBody = CohortCreateRequest;
export type CreateCohortMutationError = void | HTTPValidationError;

/**
 * @summary Create Cohort
 */
export const useCreateCohort = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCohort>>,
      TError,
      { data: CohortCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCohort>>,
  TError,
  { data: CohortCreateRequest },
  TContext
> => {
  const mutationOptions = getCreateCohortMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Cohort Templates
 */
export const getCohortTemplates = (signal?: AbortSignal) => {
  return getCohortTemplatesMutator<CohortTemplatesResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/cohorts/templates`,
    method: 'GET',
    signal,
  });
};

export const getGetCohortTemplatesQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/cohorts/templates`] as const;
};

export const getGetCohortTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohortTemplates>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortTemplates>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortTemplatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohortTemplates>>> = ({ signal }) =>
    getCohortTemplates(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohortTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCohortTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCohortTemplates>>
>;
export type GetCohortTemplatesQueryError = void | HTTPValidationError;

export function useGetCohortTemplates<
  TData = Awaited<ReturnType<typeof getCohortTemplates>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortTemplates>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohortTemplates>>,
          TError,
          Awaited<ReturnType<typeof getCohortTemplates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohortTemplates<
  TData = Awaited<ReturnType<typeof getCohortTemplates>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohortTemplates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohortTemplates>>,
          TError,
          Awaited<ReturnType<typeof getCohortTemplates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohortTemplates<
  TData = Awaited<ReturnType<typeof getCohortTemplates>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortTemplates>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Cohort Templates
 */

export function useGetCohortTemplates<
  TData = Awaited<ReturnType<typeof getCohortTemplates>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortTemplates>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCohortTemplatesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Cohort Details
 */
export const updateCohortDetails = (
  cohortId: number,
  cohortUpdateRequest: CohortUpdateRequest,
  signal?: AbortSignal,
) => {
  return updateCohortDetailsMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/cohorts/update/${cohortId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: cohortUpdateRequest,
    signal,
  });
};

export const getUpdateCohortDetailsMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCohortDetails>>,
    TError,
    { cohortId: number; data: CohortUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCohortDetails>>,
  TError,
  { cohortId: number; data: CohortUpdateRequest },
  TContext
> => {
  const mutationKey = ['updateCohortDetails'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCohortDetails>>,
    { cohortId: number; data: CohortUpdateRequest }
  > = (props) => {
    const { cohortId, data } = props ?? {};

    return updateCohortDetails(cohortId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCohortDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCohortDetails>>
>;
export type UpdateCohortDetailsMutationBody = CohortUpdateRequest;
export type UpdateCohortDetailsMutationError = void | HTTPValidationError;

/**
 * @summary Update Cohort Details
 */
export const useUpdateCohortDetails = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCohortDetails>>,
      TError,
      { cohortId: number; data: CohortUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCohortDetails>>,
  TError,
  { cohortId: number; data: CohortUpdateRequest },
  TContext
> => {
  const mutationOptions = getUpdateCohortDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Cohort Details
 */
export const getCohortDetails = (cohortId: number, signal?: AbortSignal) => {
  return getCohortDetailsMutator<CohortDetails>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/cohorts/${cohortId}`,
    method: 'GET',
    signal,
  });
};

export const getGetCohortDetailsQueryKey = (cohortId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/cohorts/${cohortId}`] as const;
};

export const getGetCohortDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohortDetails>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortDetails>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortDetailsQueryKey(cohortId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohortDetails>>> = ({ signal }) =>
    getCohortDetails(cohortId, signal);

  return { queryKey, queryFn, enabled: !!cohortId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohortDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCohortDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getCohortDetails>>>;
export type GetCohortDetailsQueryError = void | HTTPValidationError;

export function useGetCohortDetails<
  TData = Awaited<ReturnType<typeof getCohortDetails>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortDetails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohortDetails>>,
          TError,
          Awaited<ReturnType<typeof getCohortDetails>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohortDetails<
  TData = Awaited<ReturnType<typeof getCohortDetails>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohortDetails>>,
          TError,
          Awaited<ReturnType<typeof getCohortDetails>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohortDetails<
  TData = Awaited<ReturnType<typeof getCohortDetails>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortDetails>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Cohort Details
 */

export function useGetCohortDetails<
  TData = Awaited<ReturnType<typeof getCohortDetails>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortDetails>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCohortDetailsQueryOptions(cohortId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
